import React, { useState } from 'react';

import { Button, Mark, Popover, Table, Text } from '@mantine/core';

import { PassType } from '@/types/person';

import IconDelete from '@/shared/uikit/assets/icons/IconDelete.svg?react';
import IconEdit from '@/shared/uikit/assets/icons/IconEdit.svg?react';

import { IconCheck, IconX } from '@tabler/icons-react';

type PassTypesItemProps = {
	passType: PassType;
	handleEdit: (passType: PassType) => void;
	handleDelete: (id: number) => Promise<void>;
};

const PassTypesItem: React.FC<PassTypesItemProps> = ({ passType, handleEdit, handleDelete }) => {
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);

	return (
		<Table.Tr key={passType?.id}>
			<Table.Td>
				<Text size="md" fw={600} lts="normal">
					{passType.name}
				</Text>
			</Table.Td>
			<Table.Td>
				<Mark
					color="#F6FFED"
					fz={14}
					pt={3}
					pb={3}
					pr={6}
					pl={6}
					c="green"
					style={{ border: '1px solid #B7EB8F', borderRadius: '5px' }}
				>
					{passType.kind}
				</Mark>
			</Table.Td>
			<Table.Td>
				<Mark
					color="#E6F7FF"
					fz={14}
					pt={3}
					pb={3}
					pr={6}
					pl={6}
					c="blue"
					style={{ border: '1px solid #91D5FF', borderRadius: '5px' }}
				>
					{passType.id}
				</Mark>
			</Table.Td>
			<Table.Td>
				<Button.Group display="flex" style={{ justifyContent: 'center' }}>
					<Button
						variant="transparent"
						size="compact-sm"
						radius="sm"
						color="balck"
						onClick={() => handleEdit(passType)}
					>
						<IconEdit fontSize={20} color="#667085" cursor="pointer" />
					</Button>
					<Popover
						position="top"
						withArrow
						shadow="md"
						opened={isPopoverOpen}
						onChange={setIsPopoverOpen}
					>
						<Popover.Target>
							<Button
								variant="transparent"
								size="compact-sm"
								radius="sm"
								color="balck"
								onClick={() => setIsPopoverOpen((prev) => !prev)}
							>
								<IconDelete fontSize={20} color="#667085" cursor="pointer" />
							</Button>
						</Popover.Target>
						<Popover.Dropdown p={8}>
							<Text size="xs">
								<Text ta="center" fz={13}>
									Удалить?
								</Text>
								<Button.Group mt={3}>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										onClick={() => handleDelete(passType?.id)}
									>
										<IconCheck size={16} />
									</Button>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										color="red"
										onClick={() => setIsPopoverOpen(false)}
									>
										<IconX size={16} />
									</Button>
								</Button.Group>
							</Text>
						</Popover.Dropdown>
					</Popover>
				</Button.Group>
			</Table.Td>
		</Table.Tr>
	);
};

export default PassTypesItem;
